import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../constants/colors';
import { fontFamily } from '../../constants/text';
import SolvVerified from './Icons/SolvVerified';

const Root = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const BadgeCopy = styled.div`
  margin-left: 4px;
  text-transform: uppercase;
  font-family: ${fontFamily.book};
  font-size: ${props => `${props.sc.fontSize}px`};
  color: ${colors.blueMonday};
`;

const VerifiedBadge = styled(SolvVerified)`
  font-size: ${props => `${props.sc.badgeSize}px`};
`;

export default class SolvVerifiedBadge extends PureComponent {
  static propTypes = {
    badgeCopy: PropTypes.string,
    className: PropTypes.string,
    fontSize: PropTypes.number,
    badgeSize: PropTypes.number,
  };

  static defaultProps = {
    fontSize: 10,
    badgeSize: 16,
    badgeCopy: 'Verified',
  };

  render = () => (
    <Root className={this.props.className}>
      <VerifiedBadge sc={{ badgeSize: this.props.badgeSize }} />
      <BadgeCopy sc={{ fontSize: this.props.fontSize }}>{this.props.badgeCopy}</BadgeCopy>
    </Root>
  );
}
